$('#importoimmobile').blur(function(event) {
    var value = $(this).val();
    value = value.replace(/\./g, "");
    if (!isNaN(value)) {
        $.ajax({
            url: '/ajax/immobilicorrelati',
            type: 'GET',
            dataType: 'HTML',
            data: {
                importo: value
            },
        })
        .done(function(data) {
            $('#lista-immobili-container').html(data);
            $('#lista-immobili').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                respondTo: 'min',
                verticalScrolling: false,
                infinite: true,
                responsive: [
                  
                    {
                      breakpoint: 940,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                ]
            });
        })
        .fail(function() {
        })
        .always(function() {
        });

        return;
    }
});

if ($('#formMutuoPerfetto').length > 0) {

        var nCosto;
    $(document).on("click","#costo",function(){
        nCosto = $(this).val();
        $(this).val("");
    });

    $(document).on("focusout","#costo",function(){
        $(this).val(nCosto);
    });

    $("#formMutuoPerfetto").on("keyup","#costo",function(){
        var prezzo = $(this).val();
        if(prezzo.indexOf(".") > 0){
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        prezzo = parseInt(prezzo) | "";
        prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
        nCosto = prezzo;
        $("#costo").val(prezzo);
    });

    var nRedditoMensile;
    $(document).on("click","#reddito_mensile",function(){
        nRedditoMensile = $(this).val();
        $(this).val("");
    });

    $(document).on("focusout","#reddito_mensile",function(){
        $(this).val(nRedditoMensile);
    });

    $("#formMutuoPerfetto").on("keyup","#reddito_mensile",function(){
        var prezzo = $(this).val();
        if(prezzo.indexOf(".") > 0){
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        prezzo = parseInt(prezzo) | "";
        prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
        nRedditoMensile = prezzo;
        $("#reddito_mensile").val(prezzo);
    });

    var nAnticipo;
    $(document).on("click","#anticipo",function(){
        nAnticipo = $(this).val();
        $(this).val("");
    });

    $(document).on("focusout","#anticipo",function(){
        $(this).val(nAnticipo);
    });

    $("#formMutuoPerfetto").on("keyup","#anticipo",function(){
        var prezzo = $(this).val();
        if(prezzo.indexOf(".") > 0){
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        prezzo = parseInt(prezzo) | "";
        prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
        nAnticipo = prezzo;
        $("#anticipo").val(prezzo);
    });


    $("#formMutuoPerfetto").validate({
        ignore: [],
        focusInvalid: false,
        rules: {
            email: {
                required: true,
                verifyemail: true
            }
        }
    });

    $('#formMutuoPerfetto').on('click', '#inviaMutuoPerfetto', function () {
        var btn    = $(this);
        var form   = $('#formMutuoPerfetto');
        var action = form.attr('action');
        var data   = form.serialize();

        btn.prop("disabled", true);

        if ($(form).valid()) {
            $.ajax({
                url: action,
                type: 'POST',
                data: data,
            })
            .done(function(data) {
                $(form)[0].reset();
                $('#inviaMutuoPerfetto').prop("disabled", false);
                if (data.length > 0) {
                    $("#infoForm").html(data);
                    $("#infoForm").fadeIn("slow");
                }
            })
            .fail(function() {
                console.log("error");
            })
            .always(function() {
                btn.prop("disabled", false);
            });
        }
    });
}
